var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZuraguLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 32,
    viewBox: "0 0 230 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3825_23282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0469 31.6178C70.8313 31.6178 75.8219 25.4378 75.8219 17.2235V0.550781H69.3974V17.2235C69.3974 23.4644 65.3244 25.7902 60.047 25.7902C54.6784 25.7902 50.6974 23.4184 50.6974 17.2235V0.550781H47.0506C45.583 0.550781 44.2729 1.70514 44.2729 3.32743V17.2235C44.2729 25.6211 49.3548 31.6178 60.0471 31.6178H60.0469Z",
    fill: "#09111B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.624 18.0629C111.784 18.1224 114.542 13.4712 114.542 9.55574C114.542 4.74755 110.667 0.550781 105.535 0.550781H85.7701C84.1392 0.550781 82.9917 1.84022 82.9917 3.32681V31.1133H89.1866L89.2326 6.10685H104.962C106.694 6.10685 108.344 7.55398 108.344 9.62799C108.344 11.4741 106.778 13.0544 104.919 13.0544H94.8528L106.555 31.1134H113.686L104.624 18.0629H104.624Z",
    fill: "#09111B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.475 6.10685L140.143 0.550781H133.691C132.581 0.550781 131.569 1.19487 131.105 2.30626L119.059 31.1133H126.008L135.992 6.10685H142.475H142.475Z",
    fill: "#09111B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.977 31.1139H152.97L144.808 11.666H138.247L145.977 31.1139Z",
    fill: "#D6A85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.128 13.6749H176.08C174.702 13.6749 173.384 14.8088 173.384 16.4517V19.2296H184.508C182.933 23.6339 178.57 25.901 174.466 25.8819C168.85 25.856 163.793 21.6439 163.793 15.786C163.793 9.9118 168.866 5.74732 174.466 5.73275C178.34 5.73275 181.423 7.52793 183.47 10.3952H190.262C188.147 5.16932 182.66 0.0468779 174.466 0.000261038C166.273 -0.0458532 157.414 6.02087 157.414 15.7861C157.414 25.5512 165.935 31.5534 174.466 31.6168C183.918 31.6168 192.2 24.2939 191.128 13.6751V13.6749Z",
    fill: "#09111B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.225 31.6178C225.01 31.6178 230 25.4378 230 17.2235V0.550781H223.576V17.2235C223.576 23.4644 219.503 25.7902 214.225 25.7902C208.857 25.7902 204.876 23.4184 204.876 17.2235V0.550781H200.586C199.411 0.550781 198.451 1.50963 198.451 2.68561V17.2235C198.451 25.6211 203.533 31.6178 214.226 31.6178H214.225Z",
    fill: "#09111B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.156 0.550781L135.992 5.99402L136.036 6.10685H142.474L140.142 0.550781H138.156Z",
    fill: "#D6A85B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75592 6.10157H17.0231L0 31.1134H7.23289L27.7766 0.550781H4.10253V3.44806C4.10253 4.88187 5.35654 6.10157 6.75592 6.10157Z",
    fill: "#09111B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7586 25.5625H22.7375L39.7602 0.550781H32.5273L11.9839 31.1132H39.7586V25.5625Z",
    fill: "#09111B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3825_23282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 31.6179,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZuraguLogo);
export default __webpack_public_path__ + "static/media/zuragu-logo.4de0665a4bf84ef6847c68d4e09d2202.svg";
export { ForwardRef as ReactComponent };